import { render } from "./EmojiLayer.vue?vue&type=template&id=5ce191a4"
import script from "./EmojiLayer.vue?vue&type=script&lang=js"
export * from "./EmojiLayer.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__